'use client';

// Botão "Sugerir plataforma" + modal (Modal oficial do app) com autocomplete das
// plataformas ja na tabela. Salva/incrementa via Server Action.

import { useEffect, useState } from 'react';
import { TbCheck, TbWebhook } from 'react-icons/tb';

import { listRequestedPlatforms, requestPlatform } from './platform-actions';

import { Modal } from '@/components/ui/modal';

export function PlatformRequestModal() {
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState('');
  const [pool, setPool] = useState<string[]>([]);
  const [sending, setSending] = useState(false);
  const [done, setDone] = useState(false);

  // carrega as plataformas da tabela quando abre (uma vez)
  useEffect(() => {
    if (!open || pool.length) return;
    let alive = true;
    void listRequestedPlatforms().then((list) => {
      if (alive) setPool(list);
    });
    return () => {
      alive = false;
    };
  }, [open, pool.length]);

  const q = value.trim().toLowerCase();
  const suggestions = q ? pool.filter((p) => p.toLowerCase().includes(q)).slice(0, 6) : [];

  const reset = (): void => {
    setValue('');
    setDone(false);
    setSending(false);
  };

  const submit = async (): Promise<void> => {
    if (value.trim().length < 2 || sending) return;
    setSending(true);
    const res = await requestPlatform(value);
    setSending(false);
    if (res.ok) setDone(true);
  };

  return (
    <>
      <button
        type="button"
        onClick={() => {
          reset();
          setOpen(true);
        }}
        className="bg-trakd-fill text-on-brand shadow-trakd-glow-violet mt-4 inline-flex min-h-[44px] items-center gap-2 rounded-full px-6 py-3 text-base font-medium transition hover:opacity-95"
      >
        <TbWebhook size={18} /> Sugerir plataforma
      </button>

      <Modal
        open={open}
        onOpenChange={setOpen}
        tone="brand"
        icon={<TbWebhook size={20} />}
        title="Sugerir plataforma"
        description="Diz qual plataforma você usa que a gente avalia implementar."
        footer={
          done ? (
            <button
              type="button"
              onClick={() => setOpen(false)}
              className="bg-trakd-fill text-on-brand rounded-[10px] px-[18px] py-[9px] text-sm font-semibold"
            >
              Fechar
            </button>
          ) : (
            <>
              <button
                type="button"
                onClick={() => setOpen(false)}
                className="border-border-subtle text-ink-muted hover:text-ink rounded-[10px] border px-4 py-[9px] text-sm font-medium transition"
              >
                Cancelar
              </button>
              <button
                type="button"
                onClick={() => void submit()}
                disabled={value.trim().length < 2 || sending}
                className="bg-trakd-fill text-on-brand rounded-[10px] px-[18px] py-[9px] text-sm font-semibold transition hover:opacity-95 disabled:cursor-not-allowed disabled:opacity-50"
              >
                {sending ? 'Enviando…' : 'Enviar sugestão'}
              </button>
            </>
          )
        }
      >
        {done ? (
          <div className="flex flex-col items-center gap-3 py-4 text-center">
            <span className="bg-violet/15 text-violet grid h-12 w-12 place-items-center rounded-full">
              <TbCheck size={24} />
            </span>
            <p className="text-ink text-base font-semibold">Valeu! Anotado.</p>
            <p className="text-ink-muted text-sm">
              Vamos avaliar a <b className="text-ink">{value.trim()}</b>. Quanto mais gente pede,
              mais rápido entra.
            </p>
          </div>
        ) : (
          <div>
            <label
              htmlFor="platform-name"
              className="text-ink-muted mb-2 block text-[13px] font-medium"
            >
              Nome da plataforma
            </label>
            <input
              id="platform-name"
              value={value}
              onChange={(e) => setValue(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') void submit();
              }}
              autoComplete="off"
              placeholder="Ex.: Nuvemshop, Pagar.me…"
              maxLength={60}
              className="border-border-subtle focus:border-violet/60 w-full rounded-xl border bg-white/[0.03] px-3.5 py-2.5 text-sm text-white outline-none"
            />
            {suggestions.length > 0 && (
              <ul className="border-border-subtle scrollbar-ghost mt-2 max-h-[170px] overflow-y-auto rounded-xl border">
                {suggestions.map((s) => (
                  <li key={s}>
                    <button
                      type="button"
                      onClick={() => setValue(s)}
                      className="text-ink-muted hover:text-ink hover:bg-violet/10 block w-full px-3.5 py-2 text-left text-[13.5px] transition"
                    >
                      {highlight(s, q)}
                    </button>
                  </li>
                ))}
              </ul>
            )}
          </div>
        )}
      </Modal>
    </>
  );
}

function highlight(text: string, q: string) {
  if (!q) return text;
  const i = text.toLowerCase().indexOf(q);
  if (i < 0) return text;
  return (
    <>
      {text.slice(0, i)}
      <b className="text-ink font-semibold">{text.slice(i, i + q.length)}</b>
      {text.slice(i + q.length)}
    </>
  );
}

export default PlatformRequestModal;
